'use client'
import { GrandSection, HTMLArticle } from 'ui'
import type { WidgetBlog } from 'ecosystem'
import type { FC } from 'react'
import { shiftHeadings } from '../utils/headings'

interface IBlogContentProps {
  blogPost: WidgetBlog
}

const BlogContent: FC<IBlogContentProps> = ({ blogPost }) => {
  return (
    <GrandSection as="article" sectionId="content" className="blog-content">
      {/* the hero holds the post's H1; body headings start at H2 whatever level the editor used */}
      <HTMLArticle content={shiftHeadings(blogPost.content ?? '')} />
    </GrandSection>
  )
}

export default BlogContent
